export default __webpack_public_path__ + "static/you-55d1115e8726aa6bb9b37055f08a1645.jpg";